import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export default function ExamViewSnackbar(props) {
	const { open, setOpen, message, snackbarAlertState } = props;

	const handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		setOpen(false);
	};

	return (
		<div>
			<Snackbar
				open={open}
				autoHideDuration={6000}
				onClose={handleClose}
			>
				<Alert
					onClose={handleClose}
					severity={snackbarAlertState}
					variant="filled"
					sx={{ width: "100%" }}
				>
					{message}
				</Alert>
			</Snackbar>
		</div>
	);
}
